export default __webpack_public_path__ + "static/media/make1.b8f836a7.png";